import store from '@/store';
import axios from 'axios';

const url = 'https://junkit.vonigo.com/api/v1/resources/faqs/'

export default class FaqService {
    public getFAQ(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .post(url,{securityToken: store.getters.token,method:0,}, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
                )
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
